import { create } from "zustand";
import { Lingue } from "../sistema/IT";
// import  {Lingue} from "./IT"
export const useLingueStore = create((set, get) => ({
  // selectedLinguaTesto: Lingue.find((l) => l.default).value , // Default to the first language that is marked as default
  selectedLinguaTesto: {}, // Default to the first language that is marked as default
  refreshLingua: () => {
    const lan = localStorage.getItem("pageLang");
    let selLang = Lingue.find((l) => l.key === lan);
    if (selLang == null) {
      localStorage.setItem("pageLang", Lingue[0].key);

      selLang = Lingue[0];
    }
    set({ selectedLinguaTesto: selLang.value });
  },
  setSelectedLinguaTesto: (lingua) => {
    const selLang = Lingue.find((l) => l.key === lingua);
    localStorage.setItem("pageLang", lingua);
    set({ selectedLinguaTesto: selLang.value });
  },
}));
